/*
 * Created by: cparaschiv
 * Date: 06.11.2014, 15:44 
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        Widget = ui.Widget,
        List = ui.List,
        AutoComplete = ui.AutoComplete,
        CLOSE = "close",
        ENABLE = "enable",
        ISOPEN = "isOpen",
        OPEN = "open",
        VALUE = "value",
        TEXT = "text",
        READONLY = "readonly",
        unwrap = TS.unwrap;

    var TsAutoComplete = AutoComplete.extend({

        searchList: null,

        init: function (element, options) {
            var me = this,
                vm,
                domainProp;

            if (options.dataSource) {
                vm = options.getViewModel();
                domainProp = TS.Util.getProperty(vm, options.dataSource);

                if (domainProp.headerTemplate) {
                    options.headerTemplate = kendo.template(domainProp.headerTemplate);
                }
                if (domainProp.template) {
                    options.template = kendo.template(domainProp.template);
                }

                me.searchList = domainProp;
                options.dataSource = domainProp.getKendoComboConfig();
                options = $.extend({}, options, domainProp.getKendoComboConfig());
            }

            AutoComplete.fn.init.call(me, element, options);
        },

        _popup: function () {
            var me = this;

            $(me.list).addClass('ts-autocomplete');

            AutoComplete.fn._popup.call(me);
        },

        _blur: function () {
            var me = this,
                searchList = me.searchList;

            AutoComplete.fn._blur.call(me);

            if (me.value() == "")
            {
                searchList.SelectedItem(null);
                searchList.Value = null;
            }
        },

        _select: function (li) {
            var me = this,
                data = me._data(),
                searchList = me.searchList,
                editValue, idx, selectedItem;

            AutoComplete.fn._select.call(me, li);

            if (li) {
                idx = List.inArray(li[0], me.ul[0]);

                if (idx > -1) {
                    selectedItem = data[idx];
                    editValue = selectedItem[searchList.ValueMember];

                    searchList.SelectedItem(selectedItem);
                    searchList.Value = editValue;
                }
            }
        },

        open: function () {
            var listContainer = e.sender.list.closest(".k-list-container");
            listContainer.width(listContainer.width() + kendo.support.scrollbar());
        },

        options: {
            name: 'TsAutoComplete',
            autoBind: false,
            animate: false
        }

    });

    ui.plugin(TsAutoComplete);

    /*
        TsAutoComplete
    */
    ko.kendo.bindingFactory.createBinding({
        name: "kendoTsAutoComplete",
        events: {
            change: {
                writeTo: VALUE,
                value: VALUE
            },

            open: {
                writeTo: ISOPEN,
                value: true
            },

            // CP 20130529 - modified default config; don't care about ISOPEN at the moment
            // it's more important that the combo pushes both VALUE and TEXT to domain
            // so: intercept close event, read TEXT value, write to TEXT property
            close: {
                writeTo: TEXT,
                value: TEXT
            }
        },
        watch: {
            enabled: ENABLE,
            readonly: READONLY,
            isOpen: [OPEN, CLOSE],
            value: VALUE,
            text: TEXT,
            visible: ko.wrapperVisible
        }
    });

    var prevAutoCompleteSetup = ko.bindingHandlers['kendoTsAutoComplete'].setup;
    ko.bindingHandlers['kendoTsAutoComplete'].setup = function (element, options, context) {

        options.getViewModel = function () {
            var vm = context.$data;
            return vm;
        };

        if (options.dataSource) {
            var searchList = TS.getPropertyValue(context.$data, options.dataSource);
            if (searchList) {
                options.value = TS.accessor(searchList.Domain(), ts.unwrap(searchList.DisplayMember)).value;
            }
        }

        prevAutoCompleteSetup.apply(this, arguments);
    };


})(jQuery);